import {
  type TCompanyListItem,
  type TGetCompanyListParams,
} from 'features/company/types';
import { baseApi } from 'lib/rtkQuery/baseApi';
import { QueryTags } from 'lib/rtkQuery/constants';

const endpoint = '/companies';

export const companyApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [QueryTags.Company],
  })
  .injectEndpoints({
    endpoints: builder => ({
      GetCompanyList: builder.query<TCompanyListItem[], TGetCompanyListParams>({
        query: params => ({
          url: endpoint,
          method: 'GET',
          params,
        }),
        providesTags: [QueryTags.Company],
      }),
    }),
  });

export const { useGetCompanyListQuery } = companyApi;
